import React from "react";
import { i18n } from '../../translate/i18n';
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Done from "@mui/icons-material/Check";
import Cancel from "@mui/icons-material/Close";
import ThumbUp from '@mui/icons-material/ThumbUp';
import ThumbDown from '@mui/icons-material/ThumbDown';

import {
  TableCell,
  Tooltip,
} from "@mui/material";

class TableActionButtonsLegacy extends React.Component {
  deleteIcon = (index, objIndex) => (
    <IconButton onClick={() => this.props.deleteComponent(index, objIndex)} size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.delete')}>
        {this.props.type === 'like' ? <ThumbDown style={styles.colorDefaultIcons} /> : <DeleteIcon style={styles.colorDefaultIcons} />}
      </Tooltip>
    </IconButton>
  );

  editIcon = (index, initialText) => (
    <IconButton onClick={() => this.props.editComponent(index, initialText)} size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.edit')}>
        {this.props.type === 'like' ? <ThumbUp style={styles.colorDefaultIcons} /> : <EditIcon style={styles.colorDefaultIcons} />}
      </Tooltip>
    </IconButton>
  );
  okBtn = index => (
    <IconButton
      onClick={() => this.props.updateComponent(index)}
      disabled={!this.props.checkDelete && this.props.action === 'deleting'}
      size="large">
      <Tooltip title={this.props.action === 'editing' ? i18n.t('tooltipMatTableOver.true') : i18n.t('tooltipMatTableOver.false')}>
        <Done style={!this.props.checkDelete && this.props.action === 'deleting' ? styles.disabled : styles.confirm} />
      </Tooltip>
    </IconButton>
  );
  cancelBtn = () => (
    <IconButton onClick={() => this.props.cancelEdit()} size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.cancel')}>
        <Cancel style={styles.cancel} />
      </Tooltip>
    </IconButton>
  );

  render() {
    return (
      <TableCell component="th" scope="row" style={styles.tableCell}>
        {this.props.index === this.props.editedIndex
          ? this.okBtn(this.props.objContent ? this.props.objContent._id : null)
          : this.editIcon(this.props.index, this.props.objContent ? this.props.objContent.name : null)}
        {this.props.index === this.props.editedIndex
          ? this.cancelBtn()
          : this.deleteIcon(this.props.index, this.props.objContent._id)}
      </TableCell>
    );
  }
}

export const styles = {
  tableCell: {
    width: '160px',
  },
  colorDefaultIcons: {
    color: 'black',
  },
  confirm: {
    color: 'darkgreen',
    fontSize: '25px',
  },
  disabled: {
    color: 'lightgrey',
    fontSize: '25px',
  },
  cancel: {
    color: 'red',
    fontSize: '25px',
  }
}

export default TableActionButtonsLegacy;
